var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49998 6.97886C5.37948 6.97886 5.26732 6.95961 5.16348 6.92111C5.05965 6.88278 4.9609 6.81678 4.86723 6.72311L0.372982 2.22886C0.234649 2.09036 0.161315 1.91886 0.152982 1.71436C0.144648 1.51003 0.217982 1.33028 0.372982 1.17511C0.517982 1.03028 0.693648 0.957861 0.899982 0.957861C1.10632 0.957861 1.28198 1.03028 1.42698 1.17511L5.49998 5.23286L9.57298 1.17511C9.71148 1.03661 9.88298 0.963194 10.0875 0.954861C10.292 0.946527 10.4718 1.01994 10.627 1.17511C10.7718 1.31994 10.8442 1.49553 10.8442 1.70186C10.8442 1.90836 10.7718 2.08403 10.627 2.22886L6.13273 6.72311C6.03907 6.81678 5.94031 6.88278 5.83648 6.92111C5.73265 6.95961 5.62048 6.97886 5.49998 6.97886Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.ac0996cb6284552e25137337d95a1548.svg";
export { ForwardRef as ReactComponent };